<template>
<div class="banner">
	<swiper ref="mySwiper" :options="swiperOptions" class="bannerPc">
		<swiper-slide>
			<img ref="bannerImg" src="../../static/img/banner-1.jpg" alt="" />
			<div class="bannertext1">
				<p>一个属于中国航运</p>
				<p>未曾落幕的伟大里程</p>
			</div>
			<div class="phoneBanner-text1">
				<p>一个属于中国航运</p>
				<p>未曾落幕的</p>
				<p>伟大里程</p>
			</div>
		</swiper-slide>
		<swiper-slide>
			<img ref="bannerImg" src="../../static/img/banner2-2.jpg" alt="" />
		</swiper-slide>
		<swiper-slide>
			<img ref="bannerImg" src="../../static/img/banner3-2.jpg" alt="" />
		</swiper-slide>
	</swiper>
	<swiper ref="mySwiper" :options="swiperOptions" class="bannerApp">
		<swiper-slide>
			<img ref="bannerImg" src="../../static/img/banner-1.jpg" alt="" />
			<div class="bannertext1">
				<p>一个属于中国航运</p>
				<p>未曾落幕的伟大里程</p>
			</div>
			<div class="phoneBanner-text1">
				<p>一个属于中国航运</p>
				<p>未曾落幕的</p>
				<p>伟大里程</p>
			</div>
		</swiper-slide>
		<swiper-slide class="bannerAppWidth">
			<img ref="bannerImg" src="../../static/img/bannerApp2-2.jpg" alt="" />
		</swiper-slide>
		<swiper-slide class="bannerAppWidth">
			<img ref="bannerImg" src="../../static/img/bannerApp3-2.jpg" alt="" />
		</swiper-slide>
	</swiper>
	<span class="zmldown1"></span>
</div>
</template>
<script>
export default {
	data() {
		return {
			swiperOptions: {
				autoplay: {
					delay: 3000,
					disableOnInteraction: false,
				},
				effect: 'fade',
				speed: 3000,
				loop: true,
			}
		}
	},
	mounted() {

	},
	computed: {
		swiper() {
			return this.$refs.mySwiper.$swiper;
		}
	}
}
</script>
<style scoped="scoped">
.bannerApp {
	display: none;
}

img {
	display: block;
	width: 100%;
    height: 100%;
}

.banner {
	width: 100%;
	height: 100%;
	position: relative;
}

.swiper-container {
	width: 100%;
	height: 100%;
}

.swiper-wrapper {
	width: 100%;
	height: 100%;
}

.swiper-slide {
	width: 100%;
	height: 100%;
	display: flex;
	display: -ms-flexbox;
	align-items: center;
	justify-content: center;
	position: relative;
}

.bannertext1 {
	position: absolute;
	z-index: 10;
	left: 20%;
	bottom: 20%;
}

.bannertext1 p:nth-of-type(1),
.bannertext2 p:nth-of-type(1) {
	font-size: 52px;
	color: #fff;
}

.bannertext1 p:nth-of-type(2),
.bannertext2 p:nth-of-type(2) {
	font-size: 66px;
	color: #fff;
}

.bannertext2 {
	position: absolute;
	text-align: right;
	right: 15%;
	top: 50%;
	transform: translateY(-50%);
}

.bannertext3 {
	position: absolute;
	text-align: left;
	left: 20%;
	top: 30%;
	color: #fff;
}

.bannertext3 p:nth-of-type(1) {
	font-size: 46px;
}

.bannertext3 p:nth-of-type(2) {
	font-size: 66px;
	letter-spacing: 15px;
}

.bannertext3 p:nth-of-type(3) {
	font-size: 20px;
	color: rgba(255, 255, 255, .8);
	margin-top: 30px;
}

.phoneBanner-text1,
.phoneBanner-text2,
.phoneBanner-text3 {
	display: none;
}

@media only screen and (max-width: 1440px) {}

@media only screen and (max-width: 750px) {
	.bannerPc {
		display: none;
	}
	.bannerApp {
		display: block;
	}
	.bannerApp {
		justify-content: flex-start;
	}
	.bannerAppWidth img {
		width: 100%;
	}
	.bannertext1,
	.bannertext2,
	.bannertext3 {
		display: none;
	}
	.swiper-slide img {
		height: 100%;
	}
	.phoneBanner-text1,
	.phoneBanner-text2,
	.phoneBanner-text3 {
		display: block;
		position: absolute;
		color: #fff;
	}
	.phoneBanner-text1 {
		left: 5%;
		bottom: 20%;
	}
	.phoneBanner-text1 p:nth-of-type(1) {
		font-size: 24px;
		margin-bottom: 15px;
	}
	.phoneBanner-text1 p:nth-of-type(2),
	.phoneBanner-text1 p:nth-of-type(3) {
		font-size: 41px;
		line-height: 48px;
	}
	.phoneBanner-text2 {
		left: 5%;
		bottom: 18%;
		text-align: left;
	}
	.phoneBanner-text2 p:nth-of-type(1),
	.phoneBanner-text2 p:nth-of-type(2),
	.phoneBanner-text2 p:nth-of-type(3) {
		font-size: 24px;
		font-weight: 100;
	}
	.phoneBanner-text2 p:nth-of-type(4) {
		margin-top: 20px;
	}
	.phoneBanner-text2 p:nth-of-type(4),
	.phoneBanner-text2 p:nth-of-type(5) {
		font-size: 41px;
		line-height: 48px;
	}
	.phoneBanner-text3 {
		left: 5%;
		top: 25%;
	}
	.phoneBanner-text3 p:nth-of-type(1) {
		font-size: 24px;
		margin-bottom: 20px;
	}
	.phoneBanner-text3 p:nth-of-type(3),
	.phoneBanner-text3 p:nth-of-type(2) {
		font-size: 41px;
		line-height: 48px;
		letter-spacing: 5px;
	}
	.phoneBanner-text3 p:nth-of-type(4) {
		font-size: 12px;
		color: rgba(255, 255, 255, .5);
		margin-top: 20px;
		letter-spacing: 2px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/index_banner.vue